import React from 'react';
import { Text } from '../Text/Text';
import { Icon } from '../Icon/Icon';
import { IconName } from '../Icon/Icon.type';
import type { ReadOnlyProjectNoticeProps } from './ReadOnlyProjectNotice.types';

/**
 * Shown where a chat composer would be for someone who may read a project
 * but not write to it, so the missing input looks intentional.
 */
export const ReadOnlyProjectNotice: React.FC<ReadOnlyProjectNoticeProps> = ({
  message = 'You have read-only access to this project',
  className = '',
}) => (
  <div
    className={`flex items-center justify-center gap-bg-v2-sm px-bg-v2-xl py-bg-v2-lg rounded-bg-v2-xl border border-border-secondary bg-bg-secondary ${className}`}
  >
    <Icon name={IconName.Lock} size="sm" variant="secondary" />
    <Text variant="text-sm" weight="medium" color="secondary">
      {message}
    </Text>
  </div>
);

export default ReadOnlyProjectNotice;
